export const ADD_FORM_ERROR = 'ADD_FORM_ERROR';
export const REMOVE_FORM_ERROR = 'REMOVE_FORM_ERROR';
export const FORM_ERROR_SCROLL_TOP_OFF = 'FORM_ERROR_SCROLL_TOP_OFF';
